import SectionHeading from "./SectionHeading";
import { StaggerGroup, StaggerItem, Reveal } from "../shared/Reveal";
import { PATIENT_JOURNEY } from "../../data/homeContent";

export default function PatientJourney() {
  return (
    <section className="bg-surface py-20 md:py-28 lg:py-36" data-testid="patient-journey">
      <div className="container-psv">
        <SectionHeading eyebrow={PATIENT_JOURNEY.eyebrow} heading={PATIENT_JOURNEY.heading} />

        <StaggerGroup className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-x-12">
          {PATIENT_JOURNEY.steps.map((step, i) => (
            <StaggerItem key={i}>
              <div className="flex items-center gap-5 py-5 border-b border-border">
                <span className="font-serif text-2xl text-accent tabular-nums w-10 shrink-0">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <span className="font-sans text-lg text-primary">{step}</span>
              </div>
            </StaggerItem>
          ))}
        </StaggerGroup>

        <Reveal delay={0.1} className="mt-12 max-w-3xl bg-background border-l-2 border-accent p-6 rounded-r-lg">
          <p className="text-[15px] text-secondary-foreground leading-relaxed">{PATIENT_JOURNEY.note}</p>
        </Reveal>
      </div>
    </section>
  );
}
